import { NoticePageCTANotification } from "components/noticepage_components/utils"
import React from "react"
import {
  CheckmarkIcon,
  XmarkIcon,
  InfoIcon,
} from "components/page-components/Icons/small"
import createStandardGermanDateWithTime from "scripts/createStandardGermanDateWithTime"
import createStandardGermanDate from "scripts/createStandardGermanDate"
export const NoticeDetails = ({
  RefIDStringBI,
  details = {},
  failed_request,
}) => {
  const {
    CompletitionDeadline,
    applicationDate,
    areMultipleOffersAllowed,
    arePreQualificationCertificatesAccepted,
    bindDate,
    documentFromDate,
    isAdvancedSignatureAllowed,
    isApplicationRequired,
    isElectronicApplicationAllowed,
    isElectronicOfferAllowed,
    isQualifiedSignatureAllowed,
    isSideOfferAllowed,
    isTextFormAllowed,
    isWrittenOfferAllowed,
    prequalificationIssuers,
    submissionDate,
  } = details
  const application_date_config =
    applicationDate?.split("T")?.[1]?.charAt(0) !== "0"
      ? {
          timeZone: "Europe/Berlin",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
        }
      : {
          timeZone: "Europe/Berlin",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }
  const categorized_notice_details = {
    Teilnahmeantrag: isApplicationRequired
      ? {
          "Zulässige Übermittlung des Teilnahmeantrags": {
            Elektronisch: isElectronicApplicationAllowed,
            Schriftlich: !isElectronicApplicationAllowed,
          },
          "Zulässige Signaturformen": {
            Textform: isTextFormAllowed,
            "Fortgeschrittene elektronische Signatur":
              isAdvancedSignatureAllowed,
            "Qualifizierte elektronische Signatur": isQualifiedSignatureAllowed,
          },
          Präqualifizierung: arePreQualificationCertificatesAccepted
            ? { zugelassen: true }
            : { "nicht zugelassen": false },
          Präqualifikationsstellen: arePreQualificationCertificatesAccepted
            ? prequalificationIssuers?.reduce(
                (pq_issuers, key) => Object.assign(pq_issuers, { [key]: true }),
                {}
              )
            : undefined,
          "Teilnahmeantrag bis": applicationDate
            ? {
                date: new Intl.DateTimeFormat(
                  "de-DE",
                  application_date_config
                ).format(new Date(applicationDate)),
              }
            : undefined,
          "Aufforderung zur Angebotsabgabe": {
            date: new Intl.DateTimeFormat(
              "de-DE",
              application_date_config
            ).format(new Date(documentFromDate)),
          },
        }
      : undefined,
    Angebote: {
      "Übermittlung Angebote": {
        Elektronisch: isElectronicOfferAllowed,
        Schriftlich: isWrittenOfferAllowed,
      },
      "Zulässige Signaturformen": {
        Textform: isTextFormAllowed,
        "Fortgeschrittene elektronische Signatur": isAdvancedSignatureAllowed,
        "Qualifizierte elektronische Signatur": isQualifiedSignatureAllowed,
      },
      Nebenangebote: isSideOfferAllowed
        ? { zugelassen: true }
        : { "nicht zugelassen": false },
      "Mehrere Hauptangebote": areMultipleOffersAllowed
        ? { zugelassen: true }
        : { "nicht zugelassen": false },
      "Angebot bis": !!submissionDate
        ? {
            date: submissionDate.split("T")[1].startsWith("23:59")
              ? createStandardGermanDate(submissionDate)
              : createStandardGermanDateWithTime(submissionDate),
          }
        : null,
      Bindefrist: {
        date: bindDate && createStandardGermanDate(bindDate),
      },
      "Zeitraum der Ausführung": CompletitionDeadline
        ? {
            date: CompletitionDeadline,
          }
        : undefined,
    },
  }

  return (
    <React.Fragment>
      {failed_request ? (
        <div className="is-flex is-flex-direction-column">
          <p className="title is-5 mt-6 pt-6 has-text-centered has-text-mitternachtsblau">
            Achtung!
          </p>
          <p className="mb-6 has-text-centered has-text-mitternachtsblau">
            Es ist ein Fehler aufgetreten, das tut uns leid.
          </p>
        </div>
      ) : (
        <React.Fragment>
          {!!details ? (
            <React.Fragment>
              <NoticePageCTANotification
                {...{
                  current_part: "details",
                  RefIDStringBI,
                }}
              />
              <div className="columns">
                {Object.entries(categorized_notice_details).map(
                  ([main_category, category_details], cat_index) => {
                    return category_details ? (
                      <div className="column" key={`cat_${cat_index}`}>
                        <div className="box is-bordered is-shadowless has-background-mitternachtsblau-5 p-6">
                          <p className="title is-4 has-text-mitternachtsblau">
                            {main_category}
                          </p>
                          {Object.entries(category_details).map(
                            ([detail_title, detail_values], det_index) => {
                              return detail_values ? (
                                <div className="mb-5" key={`det_${det_index}`}>
                                  <p className="title is-7 has-text-evergabe mb-2">
                                    {detail_title}
                                  </p>
                                  {!!detail_values &&
                                    Object.entries(detail_values).map(
                                      ([value_title, value], val_index) => {
                                        return value_title === "date" ? (
                                          <p
                                            key={`val_${val_index}`}
                                            className="has-text-mitternachtsblau"
                                          >
                                            {value}
                                          </p>
                                        ) : (
                                          <div
                                            key={`val_${val_index}`}
                                            className="is-flex mb-2"
                                          >
                                            <div className="mr-3">
                                              {typeof value === "boolean" ? (
                                                value ? (
                                                  <CheckmarkIcon
                                                    {...{
                                                      size: 0.6,
                                                      color: "#0EAA2D",
                                                      strokeWidth: 5,
                                                    }}
                                                  />
                                                ) : (
                                                  <XmarkIcon
                                                    {...{
                                                      size: 0.45,
                                                      color: "#E70023",
                                                      strokeWidth: 6,
                                                    }}
                                                  />
                                                )
                                              ) : (
                                                <InfoIcon
                                                  {...{
                                                    size: 0.6,
                                                    strokeWidth: 6,
                                                  }}
                                                />
                                              )}
                                            </div>
                                            <div className="has-text-mitternachtsblau">
                                              {value_title}
                                            </div>
                                          </div>
                                        )
                                      }
                                    )}
                                </div>
                              ) : null
                            }
                          )}
                        </div>
                      </div>
                    ) : null
                  }
                )}
              </div>
              {isApplicationRequired ? (
                <div className="has-text-mitternachtsblau is-flex">
                  <span className="icon ml-auto mr-2">
                    <InfoIcon />
                  </span>
                  <span className="mr-auto">
                    Dies ist eine mehrstufige Vergabe
                  </span>
                </div>
              ) : null}
            </React.Fragment>
          ) : (
            <div className="is-flex is-flex-direction-column">
              <p className="title is-5 my-6 has-text-centered has-text-mitternachtsblau">
                Vergabedetails werden geladen, einen Moment bitte...
              </p>
              <div className="spinner m-auto"></div>
            </div>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
